import React from 'react'

export default function PrivacyPolicy() {
  return (
    <div className="section commonHeaderPadding">
      <div className="container-fluid maxContainerSection container-privacy-policy">
        <h2 className='text-center f-s-48 f-w-700 pb-4'>Privacy Policy</h2>

        <p className='m-0 pb-1'>
          At Quimenergy, we are committed to protecting your personal data and ensuring transparency in how we collect, use, and safeguard your information.
        </p>

        <p className='m-0 pb-1'>
          This Privacy Policy explains how we handle personal data collected through our website.
        </p>

        <h3 className='m-0 pt-4 pb-2'>1. Data We Collect</h3>

        <p className='m-0 pb-1'>
          We may collect and process the following types of personal data:
        </p>

        <ul className='m-0 pb-2'>
          <li className="pb-1">Contact information (such as name, email address, phone number).</li>
          <li className="pb-1">Information submitted through contact forms or subscription forms.</li>
          <li className="pb-1">Technical data (such as IP address, browser type, and usage data).</li>
        </ul>

        <p className='m-0 pb-1'>
          All data is collected only when voluntarily provided or through standard website analytics tools.
        </p>

        <h3 className='m-0 pt-4 pb-2'>2. Purpose of Data Processing</h3>

        <p className='m-0 pb-1'>
          Your personal data may be used for the following purposes:
        </p>

        <ul className='m-0 pb-2'>
          <li className="pb-1">To respond to inquiries and requests.</li>
          <li className="pb-1">To provide updates, newsletters, or relevant communications (when subscribed).</li>
          <li className="pb-1">To improve our website, services, and user experience.</li>
          <li className="pb-1">To ensure the security and proper functioning of the website.</li>
        </ul>

        <p className='m-0 pb-1'>We do not use your data for automated decision-making or profiling.</p>

        <h3 className='m-0 pt-4 pb-2'>3. Legal Basis for Processing</h3>

        <p className='m-0 pb-1'>
          We process personal data based on:
        </p>

        <ul className='m-0 pb-2'>
          <li className="pb-1">Your consent (e.g., when subscribing to updates).</li>
          <li className="pb-1">Legitimate business interests (e.g., improving services and communication).</li>
          <li className="pb-1">Compliance with legal obligations, where applicable.</li>
        </ul>

        <h3 className='m-0 pt-4 pb-2'>4. Data Sharing</h3>

        <p className='m-0 pb-1'>
          Quimenergy does not sell, rent, or trade personal data.
        </p>

        <p className='m-0 pb-1'>
          We may share data with trusted third-party service providers (such as hosting, analytics, or communication platforms) strictly for operational purposes and under confidentiality obligations.
        </p>

        <h3 className='m-0 pt-4 pb-2'>5. Data Retention</h3>

        <p className='m-0 pb-1'>
          Personal data will be retained only for as long as necessary to fulfill the purposes outlined in this policy or to comply with legal requirements.
        </p>

        <p className='m-0 pb-1'>
          You may request deletion of your data at any time.
        </p>

        <h3 className='m-0 pt-4 pb-2'>6. Data Security</h3>

        <p className='m-0 pb-1'>We implement appropriate technical and organizational measures to protect personal data against unauthorized access, loss, misuse, or disclosure.</p>

        <p className='m-0 pb-1'>However, no system can guarantee absolute security.</p>

        <h3 className='m-0 pt-4 pb-2'>7. Your Rights</h3>

        <p className='m-0 pb-1'>Depending on applicable laws, you may have the right to:</p>

        <ul className='m-0 pb-2'>
          <li className="pb-1">Access your personal data.</li>
          <li className="pb-1">Request correction of inaccurate data.</li>
          <li className="pb-1">Request deletion of your data.</li>
          <li className="pb-1">Withdraw consent at any time.</li>
          <li className="pb-1">Object to certain types of processing.</li>
        </ul>

        <p className='m-0 pb-1'>To exercise your rights, please contact us using the details below.</p>

        <h3 className='m-0 pt-4 pb-2'>8. Cookies and Tracking Technologies</h3>

        <p className='m-0 pb-1'>Our website may use cookies and similar technologies to enhance user experience and analyze website performance.</p>

        <p className='m-0 pb-1'>You may control or disable cookies through your browser settings.</p>

        <h3 className='m-0 pt-4 pb-2'>9. International Data Transfers</h3>

        <p className='m-0 pb-1'>In some cases, data may be processed outside Angola, including in jurisdictions with different data protection laws. In such cases, appropriate safeguards are applied.</p>

        <h3 className='m-0 pt-4 pb-2'>10. Changes to This Policy</h3>

        <p className='m-0 pb-1'>Quimenergy reserves the right to update this Privacy Policy at any time. Updates will be published on this page.</p>

        <h3 className='m-0 pt-4 pb-2'>11. Contact</h3>

        <p className='m-0 pb-1'>If you have any questions regarding this Privacy Policy or how your data is handled, please contact:</p>
        <p className='m-0 pb-1'><b>Email:</b> <a href="mailto:Geral@quimenergy.ao">Geral@quimenergy.ao</a></p>
        <p className='m-0 pb-1'><b>Address:</b> Edifício Ingombota Palace, 3º Andar, Luanda, Angola</p>

      </div>

    </div>
  )
}
